import React, { ReactNode } from 'react';

const Card = ({ children, header }: { children: ReactNode; header: string }) => (
    <article className="card">
        <div className="card-content">
            <header className="card-header">
                <h2>{header}</h2>
            </header>
            {children}
        </div>
    </article>
);
export default Card;
